/**
 * Root reducer.
 * @module reducers/root
 */

import defaultReducers from '@italia/reducers';

/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
const reducers = {
  ...defaultReducers,
  // Add your reducers here
};

export default reducers;
